import { render, staticRenderFns } from "./AccountUploadDocument.vue?vue&type=template&id=d7850a6a&scoped=true&"
import script from "./AccountUploadDocument.vue?vue&type=script&lang=js&"
export * from "./AccountUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7850a6a",
  null
  
)

export default component.exports